import { setting } from "@/common/settings";
import store from "../store/store";

export abstract class BaseService {
    //***** DEMO ******
    // protected readonly api = "https://demo.coreit.se/LetsDoIt/api/api/";
    // protected readonly api = "https://demo.coreit.se/LetsDoIt/api/api/";
    
    // protected readonly api = "http://letsdoit.azureit.se/api/api/";

    // DEBUG
    protected readonly api = setting.ApiUrl.current;
    //***** RELEASE ******
    // protected readonly api = "https://letsdoitlogin.nu/api/api/";

    //***** NEW PROD 20210126  ******
    //protected readonly api = "https://letsdoitapi.azureit.se/api/";

}